import RolePermissionGrid from './RolePermissionGrid';

export default RolePermissionGrid;
